module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/NextSliderButton/images/next-nav.53f0c13c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/NextSliderButton/images/next-nav.png
// module id = 3154
// module chunks = 11